import { useEffect, useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../lib/auth";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { login, isAuthed } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (isAuthed) nav("/admin", { replace: true }); }, [isAuthed, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      nav("/admin", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid credentials");
    } finally {
      setBusy(false);
    }
  };

  if (isAuthed) return <Navigate to="/admin" replace />;

  return (
    <section className="relative min-h-screen flex items-center justify-center bg-[#0B1F3A] text-white overflow-hidden grain">
      <div className="absolute inset-0 opacity-15 pointer-events-none" style={{ background: "radial-gradient(ellipse at top right, #C8A96A, transparent 60%)" }} />
      <div data-testid="admin-login-card" className="relative w-full max-w-md mx-6 bg-white text-[#0B1F3A] p-10 lg:p-12">
        <div className="overline text-[#C8A96A]">Concierge Team</div>
        <h1 className="mt-4 font-serif text-4xl lg:text-5xl">Sign in.</h1>
        <p className="mt-4 text-[13px] text-[#0B1F3A]/60">Restricted access · Easyilaaz operations only.</p>

        <form onSubmit={submit} className="mt-10 space-y-5">
          <div>
            <Label className="text-[11px] tracking-[0.16em] uppercase text-[#0B1F3A]/60">Email</Label>
            <Input data-testid="admin-email" className="mt-2" type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" required />
          </div>
          <div>
            <Label className="text-[11px] tracking-[0.16em] uppercase text-[#0B1F3A]/60">Password</Label>
            <Input data-testid="admin-password" className="mt-2" type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" required />
          </div>
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={busy}
            className="w-full inline-flex items-center justify-center gap-2 h-12 rounded-full bg-[#0B1F3A] text-white text-[12px] tracking-[0.18em] uppercase hover:bg-[#C8A96A] transition-colors duration-300 disabled:opacity-60"
          >
            <Lock size={14} strokeWidth={1.25} /> {busy ? "Signing in…" : "Enter Dashboard"}
          </button>
        </form>
      </div>
    </section>
  );
}
